export const blogPosts = [
  {
    id: 1,
    title: "Best Brunch Spots in Roseville CA",
    excerpt: "Discover the top brunch restaurants in Roseville CA serving everything from classic eggs benedict to creative avocado toast. Your complete guide to breakfast and brunch dining in Roseville.",
    category: "Food & Drink",
    author: "Sarah Mitchell",
    date: "2025-01-15",
    readTime: "8 min read",
    image: "https://public.readdy.ai/ai/img_res/152b3adaadc6cf9735ee455103524b4d.jpg",
    featured: true
  },
  {
    id: 2,
    title: "Moving to Roseville California: Complete 2025 Guide",
    excerpt: "Everything you need to know about relocating to Roseville CA. From neighborhoods and schools to cost of living and job market insights for families moving to Roseville California.",
    category: "Relocation",
    author: "Michael Chen",
    date: "2025-01-12",
    readTime: "12 min read",
    image: "https://readdy.ai/api/search-image?query=happy%20family%20unpacking%20moving%20boxes%20in%20beautiful%20modern%20Roseville%20California%20home%20with%20sunshine%20streaming%20through%20windows%20and%20suburban%20neighborhood%20visible%20outside&width=800&height=500&seq=blog2moving&orientation=landscape",
    featured: true
  },
  {
    id: 3,
    title: "Roseville vs Rocklin: Which City Is Right for You?",
    excerpt: "Comparing Roseville and Rocklin California for families, professionals, and retirees. Housing costs, schools, amenities, and lifestyle differences between these two popular Placer County cities.",
    category: "Relocation",
    author: "Jennifer Torres",
    date: "2025-01-10",
    readTime: "10 min read",
    image: "https://readdy.ai/api/search-image?query=split%20comparison%20view%20of%20two%20beautiful%20suburban%20California%20neighborhoods%20with%20modern%20homes%20tree%20lined%20streets%20and%20blue%20sky%20showing%20residential%20community%20lifestyle&width=800&height=500&seq=blog3comparison&orientation=landscape",
    featured: true
  },
  {
    id: 4,
    title: "Free Things to Do in Roseville CA",
    excerpt: "Explore Roseville without spending a dime. From parks and trails to free community events and family activities, discover the best free things to do in Roseville California.",
    category: "Activities",
    author: "David Park",
    date: "2025-01-08",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=families%20enjoying%20outdoor%20activities%20in%20beautiful%20California%20park%20with%20playground%20walking%20trails%20picnic%20areas%20and%20children%20playing%20under%20sunny%20blue%20sky&width=800&height=500&seq=blog4free&orientation=landscape",
    featured: false
  },
  {
    id: 5,
    title: "Best Coffee Shops in Roseville CA",
    excerpt: "Your guide to the top coffee shops and cafes in Roseville CA. From artisan espresso bars to cozy study spots, find the perfect place for your morning coffee or afternoon latte.",
    category: "Food & Drink",
    author: "Emily Rodriguez",
    date: "2025-01-05",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=cozy%20modern%20coffee%20shop%20interior%20with%20barista%20making%20latte%20art%20espresso%20machine%20pastries%20in%20display%20case%20and%20customers%20working%20on%20laptops%20in%20warm%20inviting%20atmosphere&width=800&height=500&seq=blog5coffee&orientation=landscape",
    featured: false
  },
  {
    id: 6,
    title: "Top 10 Parks in Roseville for Families",
    excerpt: "Discover the best parks and playgrounds in Roseville, perfect for family outings, picnics, and outdoor fun.",
    category: "Parks & Recreation",
    author: "Lisa Anderson",
    date: "2024-12-20",
    readTime: "5 min read",
    image: "https://readdy.ai/api/search-image?query=beautiful%20suburban%20park%20with%20modern%20playground%20equipment%20families%20playing%20children%20on%20swings%20green%20grass%20trees%20and%20blue%20sky%20in%20California%20sunshine&width=800&height=500&seq=blog6parks&orientation=landscape",
    featured: false
  },
  {
    id: 7,
    title: "Roseville's Hidden Gems: Local Businesses You Need to Know",
    excerpt: "Explore unique local shops, restaurants, and services that make Roseville special.",
    category: "Local Business",
    author: "Mark Thompson",
    date: "2024-12-15",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=charming%20local%20boutique%20shop%20storefront%20with%20welcoming%20entrance%20colorful%20window%20display%20and%20small%20business%20character%20in%20sunny%20California%20downtown%20district&width=800&height=500&seq=blog7hidden&orientation=landscape",
    featured: false
  },
  {
    id: 8,
    title: "Guide to Roseville's School Districts",
    excerpt: "Everything parents need to know about schools in Roseville, from elementary to high school.",
    category: "Education",
    author: "Rachel Green",
    date: "2024-12-10",
    readTime: "8 min read",
    image: "https://readdy.ai/api/search-image?query=modern%20California%20elementary%20school%20building%20with%20students%20walking%20to%20class%20colorful%20playground%20area%20and%20welcoming%20campus%20environment%20on%20sunny%20day&width=800&height=500&seq=blog8schools&orientation=landscape",
    featured: false
  },
  {
    id: 9,
    title: "Best Hiking Trails Near Roseville",
    excerpt: "Discover scenic trails and outdoor adventures just minutes from Roseville.",
    category: "Outdoor Activities",
    author: "Chris Martinez",
    date: "2024-12-05",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=scenic%20California%20hiking%20trail%20winding%20through%20oak%20trees%20and%20rolling%20hills%20with%20hikers%20enjoying%20nature%20and%20blue%20sky%20near%20Sacramento%20region&width=800&height=500&seq=blog9hiking&orientation=landscape",
    featured: false
  }
];